module.exports = __webpack_public_path__ + "img/team4.c9797c15.png";